import React from 'react'
import tw from 'tailwind-styled-components'
import {ContentTypeUtil, FilenameUtil} from 'yougile-util'
import {VIDEO_PREVIEW_SIZE, VideoPreview} from '@common/video-preview'
import {Icon} from '@components/common/base/icon'
import {TwIcon, TwName} from './containers'
import {FileProps} from './types'

export const File = (props: FileProps) => {
  const preview = VideoPreview.getVideoPreviewUrl(props.href)
  if (preview) {
    return <WithPreview {...props} preview={preview} />
  } else {
    return <WithoutPreview {...props} />
  }
}

const WithPreview = (props: FileProps & {preview: string}) => {
  const {href, className, onClick, preview} = props
  return (
    <TwPreview
      tabIndex={-1}
      target="_blank"
      href={href}
      className={className}
      onClick={onClick}
    >
      <TwPreviewPlayCnt />
      <TwPreviewPlay icon="IconPlayerPlayFilled" size={24} />
      <img src={preview} width={VIDEO_PREVIEW_SIZE} />
    </TwPreview>
  )
}

const TwPreviewPlayCnt = tw.div`
  absolute
  m-auto
  right-0
  left-0
  w-56
  h-56
  rounded-full
  bg-grey-l80
  shadow-sm
  group-hover/file:shadow-md
  group/file-hover:bg-grey-l100
`

const TwPreviewPlay = tw(Icon)`
  absolute
  m-auto
  right-0
  left-0
  group-hover/file:text-action-hover
  group-active/file:text-action-pressed
`

const TwPreview = tw.a`
  relative
  group/file
  cursor-pointer
  select-none
  inline-flex
  items-center
  w-fit
  min-h-128
  px-8
  py-4
  rounded-4
  shadow-border-1
  shadow-interactive-l80
  bg-interactive-l100
  hover:bg-grey-l100
`

const WithoutPreview = (props: FileProps) => {
  const {fileName, href, className, onClick} = props
  return (
    <TwFile
      tabIndex={-1}
      target="_blank"
      href={href}
      className={className}
      onClick={onClick}
    >
      <TwIcon icon={isVideo(href) ? 'IconVideo' : 'IconPaperclip'} size={16} />
      <TwName>{FilenameUtil.truncateFileName(fileName)}</TwName>
    </TwFile>
  )
}

const isVideo = (href: string): boolean => {
  if (!href.includes('.')) {
    return false
  }
  const extension = href.split('.').pop()?.split('?')[0] ?? ''
  return ContentTypeUtil.isVideoExtension(extension)
}

const TwFile = tw.a`
  group/file
  cursor-pointer
  select-none
  inline-flex
  items-center
  w-fit
  px-8
  py-4
  rounded-4
  shadow-border-1
  shadow-interactive-l80
  bg-interactive-l100
  hover:bg-grey-l100
`
